import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { isProjectRole, isAdminRole } from "../../redux/actions/userAction";
import ToggleExternalModal from './ToggleExternalModal';
import { sanitizeHtml, isHtmlContent } from './utils/sanitizeHtml';
import "./Comments.css";

/**
 * Renders comment content - handles both legacy plain text and rich text HTML
 */
const renderCommentContent = (comments) => {
  if (isHtmlContent(comments)) {
    // Rich text comment - render HTML with sanitization
    return (
      <div 
        className="comment-comment comment-html"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(comments) }}
      />
    );
  }
  // Plain text comment (legacy) - render as text
  return <div className="comment-comment">{comments}</div>;
};

const IndividualComment = ({ item, projectId, showExternalToggle }) => {
  return (
    <div className="comment-full-container">
      <div className="comment-image"></div>
      <div className="comment-content">
        <div className="comment-container">
          <div className="comment-name-time">
            {isProjectRole() ? (
              <div className="comment-name">{item.userName} </div>
            ) : (
              <></>
            )}
            <div className="comment-time">{item.timestamp}</div>
            {showExternalToggle && (isProjectRole() || isAdminRole()) ? (
              <ToggleExternalModal item={item} projectId={projectId} />
            ) : null}
          </div>
          {renderCommentContent(item.comments)}
        </div>
      </div>
    </div>
  );
};

export default IndividualComment;
